import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../Sidebar";
import { useTheme } from "../ThemeContext";
import useResponsive from "./ResponsiveHook";

export default function SkillHuntDashboard() {
  const { C } = useTheme();
  const { isMobile } = useResponsive();
  
  // ✅ L'état magique pour piloter l'ouverture du tiroir sur mobile
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div style={{ 
      display: "flex", 
      flexDirection: "row", // Reste en ligne pour laisser la barre à gauche sur PC
      height: "100vh", 
      width: "100vw",
      background: C.bgBase, 
      fontFamily: "'DM Sans', 'Inter', sans-serif",
      overflow: "hidden" 
    }}>
      <link href="https://fonts.googleapis.com/css2?family=Space+Mono:wght@400;700&family=DM+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
      
      {/* ✅ La Sidebar est toujours là, elle gère elle-même son affichage via isOpen */}
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      
      <main style={{ 
        // ✅ Se décale de 220px sur PC pour laisser la place à la Sidebar fixe
        paddingLeft: isMobile ? 0 : 220, 
        flex: 1, 
        display: "flex", 
        flexDirection: "column", 
        height: "100vh",
        position: "relative",
        minWidth: 0 // Sécurité anti-débordement flexbox
      }}>
        {/* ✅ On passe la fonction d'ouverture dans le context de l'Outlet.
          Toutes les pages enfants (comme Profile.jsx) y auront accès pour la donner à leur Topbar !
        */}
        <Outlet context={{ onMenuClick: () => setIsSidebarOpen(true) }} />
      </main>
    </div>
  );
}